import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  CircularProgress,
  Typography,
  Autocomplete,
} from "@mui/material";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import UpdateIcon from "@mui/icons-material/Update";
import { motion } from "framer-motion";
import Swal from "sweetalert2";
import CloseIcon from "@mui/icons-material/Close"; // import at
import { styled } from "@mui/system";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DOMPurify from "dompurify";
import configServ from "../../../services/config";
import CardHeadMenu from "../CardHeadMenu/CardHeadMenu";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#1976d2", // MUI blue
  color: "#fff",
  fontWeight: "bold",
}));

const StyledEvenRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: "#f5f5f5", // light grey
}));

const FaqsPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const companyId = parseInt(queryParams.get("company_id"), 10);
  const itemId = parseInt(queryParams.get("id"), 10);
  const titlee = queryParams.get("title");
  const [customers, setCustomers] = useState([]);

  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false); // For update state
  const [formData, setFormData] = useState({
    about: "",
    date_of_joining: "",
    status: true,
    brand_id: "",
  });
  const [validationErrors, setValidationErrors] = useState({});

  console.log("companyId:", companyId, "itemId:", itemId);

  // Handle popup (open/close form)
  const handlePopup = () => {
    try {
      if (isCreate === true) {
        clear();
      }
      setIsCreate(!isCreate);
    } catch (error) {
      console.log(error);
    }
  };

  // Clear form fields
  const clear = () => {
    setFormData({
      about: "",
      date_of_joining: "",
      status: true,
    });
    setValidationErrors({});
    setIsEdit(false);
  };

  const cancel = () => {
    clear();
    setIsCreate(false);
  };

  // Handle input changes
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Validate form fields
  const validate = () => {
    const errors = {};
    if (!formData.about?.trim()) errors.about = "Question is required.";
    if (!formData.date_of_joining?.trim())
      errors.date_of_joining = "date of joing is required.";
    return errors;
  };

  // Submit form
  const handleSubmit = async () => {
    const errors = validate();
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    try {
      const payload = {
        ...formData,
        company_id: companyId,
        customer_id: itemId,
      };

      if (isEdit) {
        console.log("Updating FAQ:", payload);
        const res = await configServ.storeOrUpdateMentorDetails(payload);
        if (res.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "updated successfully.",
          });
          clear();
          setIsCreate(false);
          fetchfaqs();
        }
      } else {
        // Make create API call here
        console.log("Creating FAQ:", payload);
        const res = await configServ.storeOrUpdateMentorDetails(payload);
        if (res.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "created successfully.",
          });
          clear();
          setIsCreate(false);
          fetchfaqs();
        }
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  const [faqs, setFaqs] = useState([]);
  const [loader, setLoader] = useState(true);

  const fetchfaqs = async () => {
    try {
      setLoader(true);
      const payload = {
        company_id: companyId,
        customer_id: itemId,
      };

      const res = await configServ.getCustomerDetails(payload);
      if (res.success) {
        const result = Array.isArray(res.data) ? res.data : [res.data];
        setFaqs(result);
      } else {
        setFaqs([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchfaqs();
  }, []);

  const handleEdit = (faq) => {
    console.log("faq", faq);
    setIsCreate(true);
    setFormData(faq);
    setIsEdit(true);
  };

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      [{ font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }], // ✅ Text and background color
      [{ script: "sub" }, { script: "super" }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
      ["link", "image", "video"],
      ["clean"], // remove formatting
    ],
  };

  const quillFormats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "list",
    "bullet",
    "indent",
    "align",
    "link",
    "image",
    "video",
  ];

  // Helper: Convert HTML to plain text
  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  // Helper: Truncate text to 2-3 lines
  const truncateText = (text, maxLength = 150) => {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };
  const truncateHtml = (html, maxLength = 200) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || div.innerText || "";
    const truncated =
      text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    return `<div>${truncated}</div>`; // wrap it so innerHTML can render
  };

  const fetchCustomerList = async () => {
    try {
      const result = await configServ.get_customer({
        company_id: companyId,
      });

      setCustomers(result);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    if (isCreate) {
      fetchCustomerList();
    }
  }, [isCreate]);

  const highlightMatch = (text, query) => {
    try {
      const words = query.toLowerCase().split(" ").filter(Boolean);
      const regex = new RegExp(`(${words.join("|")})`, "gi");

      return text.split(regex).map((part, index) =>
        words.includes(part.toLowerCase()) ? (
          <mark key={index} style={{ backgroundColor: "#ffe58f" }}>
            {part}
          </mark>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        )
      );
    } catch (e) {
      console.error("Error in highlightMatch:", e);
      return text;
    }
  };
  const [brandList, setBrandList] = useState([]);

  const fetchBrand = async () => {
    try {
      const dataToSend = {
        company_id: companyId,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
      };
      const res = await configServ.getBrand(dataToSend);
      if (res.status === 200) {
        setBrandList(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchBrand();
  }, []);

  return (
    <>
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Add DETAILS"}
        handlePopup={handlePopup}
        create={isCreate}
        showCreate={faqs.length > 0 ? false : true}
      />

      {isCreate === true && (
        <Container>
          <Grid
            container
            alignItems="center"
            justifyContent="flex-start"
            spacing={1}
          >
            <Grid item xs={6} md={3}></Grid>
            <Grid
              container
              item
              xs={6}
              md={9}
              justifyContent={"flex-start"}
            ></Grid>
          </Grid>

          <motion.div
            style={{
              width: "100%",
              backgroundColor: "#e3f3fc",
              padding: 20,
              borderRadius: "10px",
              border: "none",
            }}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.1, delay: 0.1 }}
          >
            <Grid
              container
              alignItems="flex-end"
              justifyContent="flex-start"
              spacing={1}
            >
              <Grid container spacing={2}>
                {/* <Grid item xs={12} md={3}>
                  <Autocomplete
                    disablePortal
                    fullWidth
                    size="small"
                    id="customer_id"
                    name="customer_id"
                    options={customers}
                    getOptionLabel={(option) => option.fname}
                    filterOptions={(options, { inputValue }) => {
                      const words = inputValue
                        .toLowerCase()
                        .split(" ")
                        .filter(Boolean);

                      return options.filter((customer) =>
                        words.every(
                          (word) =>
                            customer.fname.toLowerCase().includes(word) ||
                            (customer.mobile && customer.mobile.includes(word))
                        )
                      );
                    }}
                    sx={{ background: "white" }}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        // Use changeHandler directly with simulated event
                        changeHandler({
                          target: {
                            name: "customer_id",
                            value: newValue.id,
                          },
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Firm Name"
                        name="customer_id"
                        onChange={changeHandler}
                        fullWidth
                      />
                    )}
                    renderOption={(props, option, { inputValue }) => (
                      <li {...props}>
                        <Box display="flex" flexDirection="column">
                          <Typography variant="body2">
                            {highlightMatch(option?.fname, inputValue)}
                          </Typography>
                          {option?.mobile && (
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {highlightMatch(option?.mobile, inputValue)}
                            </Typography>
                          )}
                        </Box>
                      </li>
                    )}
                  />
                </Grid> */}

                <Grid item xs={12} md={6}>
                  <Autocomplete
                    options={brandList}
                    getOptionLabel={(option) => option.brand_name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    value={
                      brandList.find(
                        (b) => b.id === parseInt(formData.brand_id)
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      setFormData((prev) => ({
                        ...prev,
                        brand_id: newValue ? Number(newValue.id) : "", // ✅ fix here
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Branch"
                        size="small"
                        fullWidth
                        sx={{ backgroundColor: "white" }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="Date of Joining"
                    type="date"
                    name="date_of_joining"
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    onChange={changeHandler}
                    value={formData.date_of_joining}
                    sx={{ width: "100%", backgroundColor: "white" }}
                  />
                  {validationErrors.date_of_joining && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {validationErrors.date_of_joining}
                    </p>
                  )}
                </Grid>

                {/* Question Title with ReactQuill */}
                <Grid item xs={12} md={12}>
                  <label
                    style={{
                      fontSize: "14px",
                      fontWeight: 500,
                      marginBottom: "4px",
                      display: "block",
                    }}
                  >
                    Abouts
                  </label>
                  <ReactQuill
                    theme="snow"
                    value={formData.about || ""}
                    onChange={(value) =>
                      changeHandler({ target: { name: "about", value } })
                    }
                    modules={quillModules}
                    formats={quillFormats}
                    style={{
                      backgroundColor: "white",
                      minHeight: "120px",
                      maxHeight: "300px",
                      overflowY: "auto",
                    }}
                  />
                  {validationErrors.about && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {validationErrors.about}
                    </p>
                  )}
                </Grid>

                {/* Answer with ReactQuill */}
                {/* <Grid item xs={12} md={12}>
                  <label
                    style={{
                      fontSize: "14px",
                      fontWeight: 500,
                      marginBottom: "4px",
                      display: "block",
                    }}
                  >
                    Answer
                  </label>
                  <ReactQuill
                    theme="snow"
                    value={formData.answer || ""}
                    onChange={(value) =>
                      changeHandler({ target: { name: "answer", value } })
                    }
                    modules={quillModules}
                    formats={quillFormats}
                    style={{
                      backgroundColor: "white",
                      minHeight: "120px",
                      maxHeight: "300px",
                      overflowY: "auto",
                    }}
                  />
                  {validationErrors.answer && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {validationErrors.answer}
                    </p>
                  )}
                </Grid> */}

                {/* Checkbox */}
                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="status"
                        checked={Boolean(formData.status)}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            status: e.target.checked,
                          }))
                        }
                      />
                    }
                    label="Active"
                  />
                </Grid>
              </Grid>
              {/* Buttons */}

              <Grid
                container
                alignItems="flex-end"
                justifyContent="flex-end"
                mt={2}
                spacing={1}
              >
                <Grid
                  container
                  item
                  xs={12}
                  md={isEdit ? 12 : 8}
                  justifyContent={"flex-start"}
                ></Grid>

                {/* Cut/Cancel Button */}
                {isEdit ? (
                  <>
                    {" "}
                    <Grid item xs={6} md={2}>
                      <Button
                        fullWidth
                        color="error"
                        onClick={cancel} // ya koi aur cancel logic agar hai toh
                        variant="contained"
                        size="small"
                        title="Cancel"
                        startIcon={<CloseIcon />}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </>
                ) : (
                  <></>
                )}

                {/* Reset Button */}
                {isEdit ? (
                  <> </>
                ) : (
                  <>
                    <Grid item xs={6} md={2}>
                      <Button
                        fullWidth
                        color="secondary"
                        onClick={clear}
                        variant="contained"
                        size="small"
                        title="Reset"
                        startIcon={<RotateLeftIcon />}
                      >
                        Reset
                      </Button>
                    </Grid>
                  </>
                )}

                {/* Save / Update Button */}
                <Grid item xs={6} md={2}>
                  <Button
                    fullWidth
                    onClick={handleSubmit}
                    variant="contained"
                    color={isEdit ? "success" : "primary"}
                    startIcon={isEdit ? <UpdateIcon /> : <SaveIcon />}
                    size="small"
                  >
                    {isEdit ? "Update" : "Save"}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </motion.div>
        </Container>
      )}

      <Box display="flex" justifyContent="center" alignItems="center" mt="5">
        <Typography variant="h4">{titlee}</Typography>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>Sn.no</StyledTableCell>
              <StyledTableCell>About</StyledTableCell>
              <StyledTableCell>Date Of Joining</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loader ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <CircularProgress size={24} />
                </TableCell>
              </TableRow>
            ) : faqs.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography variant="body1">No Data Found</Typography>
                </TableCell>
              </TableRow>
            ) : (
              faqs.map((faq, index) => {
                const RowComponent = index % 2 === 0 ? StyledEvenRow : TableRow;
                return (
                  <RowComponent key={faq.id}>
                    <TableCell>{index + 1}</TableCell>

                    {/* Question */}
                    <TableCell
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: 200,
                        p: 1,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: faq.about }}
                        style={{
                          display: "-webkit-box",
                          WebkitLineClamp: 4,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      />
                    </TableCell>

                    {/* Answer */}
                    <TableCell
                      sx={{
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: 200,
                        p: 1,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: faq.date_of_joining,
                        }}
                        style={{
                          display: "-webkit-box",
                          WebkitLineClamp: 4,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      />
                    </TableCell>

                    {/* Status */}
                    <TableCell>
                      {faq.status === 1 || faq.status === "1" ? "✅" : "❌"}
                    </TableCell>

                    {/* Action */}
                    <TableCell>
                      <IconButton onClick={() => handleEdit(faq)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </RowComponent>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default FaqsPage;
